import { getTestId } from '@airtel/air-design-system';
var singleBreakPoint = {
  slidesPerPage: 1,
  slidesToScroll: 1,
  itemSpacing: 0,
  seekGap: 0
};
var carousalBreakPoint = {
  xs: Object.assign({}, singleBreakPoint),
  sm: Object.assign({}, singleBreakPoint),
  md: Object.assign({}, singleBreakPoint),
  lg: Object.assign({}, singleBreakPoint),
  xl: Object.assign({}, singleBreakPoint)
};
export var defaultProps = Object.assign({
  carousalProps: {
    breakPoints: carousalBreakPoint
  }
}, getTestId('InformationBannerWidgetContainer'));